var exports = {};
exports = function (creditCardDetails) {
  return creditCardDetails && creditCardDetails.hasOwnProperty("fastlane") && creditCardDetails.fastlane;
};
export default exports;